import { Status } from './status';


export interface Project {
  id: number;
  statusId?: number;
  status?: Status;
  environmentId?: number;
  environment?: any;
  name?: string;
  state?: string;
  guid?: string;
  meta?: any;
  abr?: string;
  image?: any;
  [key: string]: any;
}
